
import { useEffect, useMemo, useState } from 'react';
import { isEmpty } from 'lodash-es';
import { storage } from "@/utils/utils";
import { useLocal } from '@/pages/dashboard/utils/customHook';
import { notification } from 'tea-component';
import { getSaveValue } from './util';
const useSaveInput = (props: any) => {
  const {
    value,
    filterSaveKey,
    gameCode,
    inputList,
  } = props;
  const { getLocalText, formatMessage } = useLocal('filter');

  const [filterModalInfo, setFilterModalInfo] = useState({ filterModalType: '', filterModalVisible: false });
  const [isInit, setIsInit] = useState(true);
  const [selectedValue, setSelectedValue] = useState({});
  const [formValue, setFormValue] = useState(value);
  const [updateIndex, setUpdateIndex] = useState(0);

  // 依赖value值更新筛选器保存值
  useEffect(() => {
    setFormValue(value);
  }, [JSON.stringify(value)]);


  const { filterSaveList, selectorSchemeList, defaultSelectedItem } = useMemo(() => {
    const filterSaveList = storage.getItem(filterSaveKey) || {};
    const selectorSchemeList: any = filterSaveList?.[gameCode] || [];
    // 格式后的方案
    // TODO
    // 筛选器保存页面展示的默认方案，
    const defaultSelectedItem = selectorSchemeList?.filter((item: any) => item?.is_default)?.[0] || [];
    return { filterSaveList, selectorSchemeList, defaultSelectedItem };
  }, [filterSaveKey, gameCode, updateIndex]);

  useEffect(() => {
    // 限制编辑后引发的defaultSelectedItem变化，导致重新setSelectedValue
    if (!isInit || isEmpty(defaultSelectedItem)) return;
    setSelectedValue(defaultSelectedItem);
    setIsInit(false);
  }, [JSON.stringify(defaultSelectedItem)]);

  const filterSchemeChange = (val: any) => {
    setSelectedValue(val);
    // 设置筛选器保存值
    const newVal = getSaveValue(val, inputList);
    setFormValue(newVal);
  };

  // 筛选器方案保存
  const addFilterSchemeList = (params: any, callback: () => void) => {
    try {
      const { is_default: isDefault, } = params || {};
      // 追加方案列表
      filterSaveList[gameCode] = isDefault ? [...(selectorSchemeList?.map((item: any) => ({ ...item, is_default: false })) || []), params] : [...(selectorSchemeList || []), params];
      // 设置缓存
      storage.setItem(filterSaveKey, filterSaveList);
      // 更新方案列表
      setUpdateIndex(updateIndex + 1);
      // 提示
      notification.success({
        description: getLocalText('save_save_success'),
        className: 'filter-lock-alert',
        duration: 1000,
      });
      callback?.();
    } catch (error) {
      notification.error({
        description: getLocalText('save_save_fail'),
        className: 'filter-lock-alert',
        duration: 1000,
      });
    }
  };
  // 筛选器方案编辑
  const editFilterSchemeList = (params: any, callback: () => void) => {
    const { editFilter, ...restParams } = params || {};
    const { filter_name: filterName, } = restParams || {};
    try {
      const filterList = selectorSchemeList?.map((item: { filter_name: any; }) => item?.filter_name || '') || [];
      // 方案名称相同，提示
      const isHaveSameName = filterList?.includes(filterName?.trim());
      const newselectorSchemeList = selectorSchemeList?.map((item: any) => {
        // 更新方案名称相同方案
        if (item?.filter_name === filterName) {
          return restParams;
        }
        // 方案名称不同，更新原方案
        if (item?.filter_name === editFilter?.filter_name && !isHaveSameName) {
          return restParams;
        }
        return item;
      });
      // 如果编辑的是正在应用的方案，更新选中值
      if (editFilter?.filter_name === selectedValue?.filter_name) {
        setSelectedValue(restParams);
      }
      // 更新方案列表
      filterSaveList[gameCode] = newselectorSchemeList;
      // 设置缓存
      storage.setItem(filterSaveKey, filterSaveList);
      // 更新方案列表
      setUpdateIndex(updateIndex + 1);
      // 提示
      notification.success({
        description: isHaveSameName
          ? getLocalText('edit_same_name_success', { name: filterName })
          : getLocalText('edit_success'),
        className: isHaveSameName
          ? 'filter-lock-alert-same-name'
          : 'filter-lock-alert',
        duration: 1000,
      });
      callback?.();
    } catch (error) {
      notification.error({
        description: getLocalText('edit_fail'),
        className: 'filter-lock-alert',
        duration: 1000,
      });
    }
  };

  // 筛选器方案删除
  const deleteFilterSchemeList = (params: any, callback: () => void) => {
    const { filter_name: filterName, } = params || {};
    try {
      filterSaveList[gameCode] = selectorSchemeList?.filter((item: any) => item?.filter_name !== filterName);
      // 设置缓存
      storage.setItem(filterSaveKey, filterSaveList);
      // 更新方案列表
      setUpdateIndex(updateIndex + 1);
      notification.success({
        description: formatMessage({ id: 'filter_save_delete_success' }),
        className: 'filter-lock-alert',
        duration: 1000
      });
      callback?.();
    } catch (error) {
      notification.error({
        description: formatMessage({ id: 'filter_save_delete_fail' }),
        className: 'filter-lock-alert',
        duration: 1000
      });
    }
    setSelectedValue({});
  };

  return {
    formValue,
    setFormValue,
    selectorSchemeList,
    defaultSelectedItem,
    filterSchemeChange,
    addFilterSchemeList,
    editFilterSchemeList,
    deleteFilterSchemeList,
    selectedValue,
    setSelectedValue,
    filterModalInfo,
    setFilterModalInfo,
  };
};

export default useSaveInput;